import { render, staticRenderFns } from "./OnDemandSection.vue?vue&type=template&id=67a43d8c"
import script from "./OnDemandSection.vue?vue&type=script&lang=js"
export * from "./OnDemandSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports